export enum RequestState {
	IDLE,
	PENDING,
	SUCCESS,
	ERROR,
}

export enum NetworkErrorCodes {
	UNAUTHENTICATED = 401,
	NOT_FOUND = 404,
}

export enum ModalType {
	LOGIN,
	REGISTRATION,
	FORGOT_PASSWORD,
	FORGOT_PASSWORD_CONFIRM,
	RESET_PASSWORD,
	ERROR,
	LEAGUE_JOINED,
	LEAGUE_REMOVE_USER,
	LEAGUE_LEAVE,
	LEAGUE_REMOVE,
	PASSWORD_CHANGED,
	ACCOUNT_UPDATED,
	SECOND_REGISTRATION,
	CONTEST_SHARE,
	SHARE_MODAL,
}

/**
 * @inheritDoc https://geniussports.atlassian.net/wiki/spaces/GSM/pages/3882942870/F2P+PP+-+Status+flows#Publication-Status
 */
export enum PublishStatus {
	DRAFT = "Draft",
	PUBLISHED = "Published",
	VOIDED = "Voided",
}

export enum SocialNetwork {
	FACEBOOK,
	TWITTER,
	MOBILE,
}

export enum ShareType {
	LEAGUE = "league",
	CONTEST = "contest",
}

export enum LeagueType {
	ALL = "all",
	PRIVATE = "private",
	PUBLIC = "public",
}

export enum LeagueClass {
	REGULAR = "regular",
	OVERALL = "overall",
}

export enum LeagueStatus {
	SCHEDULED = "Scheduled",
	COMPLETED = "Completed",
	ACTIVE = "Active",
}

export enum TranslationJSONMockData {
	ExistKey = "translation.test.mock",
	ExistValue = "Test Translation",
	NonExistKey = "translation.test.mock_not_exist",
	NonExistValue = "Translation that does not exist",
}

export enum HelpPagesEnum {
	GUIDELINES = "guidelines",
	TERMS = "terms",
	PRIVACY = "privacy",
	HOW_TO_PLAY = "how_to_play",
	PRIZES = "prizes",
}

export enum QuestionHeaderStatus {
	CORRECT = "correct",
	INCORRECT = "incorrect",
	DISABLED = "disabled",
}

export enum ContestStatus {
	ACTIVE = "active",
	COMPLETED = "completed",
	SCHEDULED = "scheduled",
}

export enum Language {
	ENGLISH = "en",
	FRENCH = "fr",
}

export enum Locale {
	EN_US = "en-us",
	FR_CA = "fr-ca",
}

export enum TeamType {
	ALS = "als",
	ARGOS = "argos",
	BOMBERS = "bombers",
	ELKS = "elks",
	LIONS = "lions",
	REDBLACKS = "redblacks",
	RIDERS = "riders",
	STAMPS = "stamps",
	TICATS = "ticats",
}

export enum SponsorType {
	LOGO = "logo",
	LOGO_HEADER = "logo_header",
	LOGO_ALT = "logo_alt",
	LOGO_CHIPS = "logo_chips",
	MAIN_BANNER = "main_banner",
	SECOND_BANNER = "second_banner",
	MOBILE_BANNER = "mobile_banner",
}

export enum ContestBannerType {
	Home = "Home",
	NextUp = "NextUp",
}
